import { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion, DateInput, ModalGeneric } from 'ypf-pas-general-ui-components';

import './ApproveOrRejectSelectedQuantitiesModal.scss';

import BoxesWithText from '../../MonthlyServiceRequest/BoxesWithText/BoxesWithText';
import { getUbicationsHeaderData } from '../../../services/workReport';
import useToast from '../../../hooks/useToast';
import LoaderContext from '../../../context/LoaderProvider';
import { useWorkReportModals } from '../../../context/WorkReportModalsContext';

import SelectedQuantities from './SelectedQuantities/SelectedQuantities';

const ApproveOrRejectSelectedQuantitiesModal = (props) => {
  const { showModal } = useWorkReportModals();
  const { setNewToast } = useToast();
  const [ubicationHeaderData, setUbicationHeaderData] = useState([]);
  const [openedAccordion, setOpenedAccordion] = useState([]);

  const { setLoader } = useContext(LoaderContext);
  const {
    agrupaPorUbicacion,
    show,
    onHide,
    idsPartesDiario,
    handlePrimaryAction,
    modalTitle,
    labelPrimaryButton
  } = props;

  const toggleAccordion = (index) => {
    if (openedAccordion.includes(index)) {
      const newOpenedAccordion = openedAccordion.filter((item) => item !== index);

      setOpenedAccordion(newOpenedAccordion);

      return;
    }

    setOpenedAccordion((prev) => [...prev, index]);
  };

  const fetchUbicationHeaderData = useCallback(async () => {
    try {
      setLoader(true);
      const data = await getUbicationsHeaderData(idsPartesDiario, agrupaPorUbicacion);

      setUbicationHeaderData(data);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    } finally {
      setLoader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agrupaPorUbicacion, idsPartesDiario, showModal.approveOrRejectSelectedQuantitiesModal]);

  useEffect(() => {
    if (!showModal.approveOrRejectSelectedQuantitiesModal) return;
    fetchUbicationHeaderData({ idsPartesDiario, agrupaPorUbicacion });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal.approveOrRejectSelectedQuantitiesModal]);

  // Reseting closed state for accordions
  useEffect(() => {
    if (!showModal.approveOrRejectSelectedQuantitiesModal) return;
    setOpenedAccordion([]);
  }, [showModal.approveOrRejectSelectedQuantitiesModal]);

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onHide}
      primaryAction={() => {
        handlePrimaryAction();
        onHide();
      }}
      primaryActionLabel={labelPrimaryButton}
      secondaryAction={onHide}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title={modalTitle}
    >
      <div className="approve-modal-date">
        <h6>Fechas seleccionadas</h6>
        <div className="d-flex align-items-center justify-content-end gap-2">
          <h6>Desde</h6>
          <DateInput className="date-input-custom" value={ubicationHeaderData.desde} />
        </div>
        <div className="d-flex align-items-center gap-2">
          <h6>Hasta</h6>
          <DateInput className="date-input-custom" value={ubicationHeaderData.hasta} />
        </div>
      </div>

      <div className="monthly-pte-autorizar-accordion flex-column">
        {ubicationHeaderData?.cabeceras?.map((ubication, index) => (
          <Accordion
            availableManualOpening
            className="mb-2"
            key={`${ubication.proveedor}-${ubication.ubicacion}`}
            leftContent={
              <p
                className="d-flex flex-column align-items-start my-auto"
                style={{ fontSize: '18px' }}
              >
                <span style={{ fontSize: '18px', fontWeight: 'bolder' }}>
                  {agrupaPorUbicacion ? 'Ubicación' : 'Proveedor'}
                </span>
                <BoxesWithText>
                  <span>{agrupaPorUbicacion ? ubication.ubicacion : ubication.proveedor}</span>
                </BoxesWithText>
              </p>
            }
            setShowManualContent={() => toggleAccordion(index)}
            showManualContent={openedAccordion.includes(index)}
            width="100%"
          >
            <>
              <div className="ubication-provider-div">
                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                  {agrupaPorUbicacion ? ubication.proveedor : ubication.ubicacion}
                </span>
              </div>
              <SelectedQuantities
                idsPartesDiarios={ubication.idsPartesDiarios}
                isOpened={openedAccordion.includes(index)}
              />
            </>
          </Accordion>
        ))}
      </div>
    </ModalGeneric>
  );
};

export default ApproveOrRejectSelectedQuantitiesModal;

ApproveOrRejectSelectedQuantitiesModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  idsPartesDiario: PropTypes.arrayOf(PropTypes.number),
  agrupaPorUbicacion: PropTypes.bool,
  handlePrimaryAction: PropTypes.func,
  modalTitle: PropTypes.string.isRequired,
  labelPrimaryButton: PropTypes.string.isRequired
};

ApproveOrRejectSelectedQuantitiesModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  idsPartesDiario: [],
  agrupaPorUbicacion: false,
  handlePrimaryAction: () => {}
};
